import {
  ApolloClient,
  ApolloLink,
  InMemoryCache,
  createHttpLink,
} from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { fetchAuthSession } from "aws-amplify/auth";
import { createEnhancedApolloErrorLink } from "./shared/apolloErrorLink";

const graphQLUrl = import.meta.env.VITE_GRAPHQL_URL;

export const buildPublicUrl = (baseUrl: string): string =>
  baseUrl.replace(/\/+$/, "") + "-public";

const graphQLPublicUrl = buildPublicUrl(graphQLUrl);

const PUBLIC_OPERATIONS = [
  "UpdateAppealStatusWithToken",
  "CreateAppealStaging",
];

const authenticatedHttpLink = createHttpLink({ uri: graphQLUrl });
const publicHttpLink = createHttpLink({ uri: graphQLPublicUrl });

const authLink = setContext(async (_, { headers }) => {
  const session = await fetchAuthSession();

  const token = session?.tokens?.accessToken.toString();

  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    },
  };
});

const isPublicOperation = (operationName: string | undefined): boolean =>
  PUBLIC_OPERATIONS.includes(operationName ?? "");

const routingLink = ApolloLink.split(
  (operation) => isPublicOperation(operation.operationName),
  publicHttpLink,
  authLink.concat(authenticatedHttpLink),
);

const errorLink = createEnhancedApolloErrorLink();

const graphQLClient = new ApolloClient({
  cache: new InMemoryCache({}),
  link: errorLink.concat(routingLink),
  devtools: {
    enabled: false,
  },
});

export default graphQLClient;
